import { Link } from "react-router-dom";
import { useSeo } from "../lib/useSeo";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function CheckoutCancelled() {
  useSeo({
    title: "Payment cancelled · Railway Careers UK",
    canonical: "/checkout/cancelled",
    noindex: true,
  });
  return (
    <div className="bg-cream min-h-screen flex items-center" data-testid="checkout-cancelled-page">
      <div className="max-w-xl mx-auto px-6 py-20 w-full text-center">
        <div className="bg-card border border-border rounded-xl p-8 md:p-10 shadow-sm">
          <div className="w-14 h-14 rounded-full bg-muted inline-flex items-center justify-center mx-auto">
            <XCircle className="w-7 h-7 text-muted-foreground" />
          </div>
          <h1 className="font-display font-extrabold text-ink text-3xl tracking-tight mt-5">
            Payment cancelled
          </h1>
          <p className="text-muted-foreground mt-3 text-sm">
            No problem — no charge has been taken. You can retry whenever you're ready.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="bg-navy text-bone hover:bg-lime-600 hover:text-ink">
              <Link to="/employers#pricing">Back to pricing</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/employer-portal/dashboard">Dashboard</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
